import {ClickerGCSEngine} from './ClickerGame.types';
import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {DevPanelService} from '@/services/DevPanelService/DevPanelService';

import {BonusesObserverScript} from './scripts/BonusesObserverScript';
import {OnboardingScript} from './scripts/OnboardingScript';
import {SpawnBonusesScript} from './scripts/SpawnBonusesScript';
import {StartUpScript} from './scripts/StartUpScript';
import {VisibilityChangeScript} from './scripts/VisibilityChangeScript';

export class ClickerGameScene {
  constructor(
    private readonly engine: ClickerGCSEngine,
    private readonly startUpScript: StartUpScript,
    private readonly spawnBonusesScript: SpawnBonusesScript,
    private readonly bonusesObserverScript: BonusesObserverScript,
    private readonly onboardingScript: OnboardingScript,
    private readonly visibilityChangeScript: VisibilityChangeScript,
    private readonly devPanel: DevPanelService,
  ) {}

  public async create(container: HTMLElement): Promise<void> {
    await this.engine.renderer.asyncCreate(container);

    this.engine.scripts.addScript(
      this.startUpScript,
      this.spawnBonusesScript,
      this.bonusesObserverScript,
      this.onboardingScript,
      this.visibilityChangeScript,
    );

    this.engine.start();
  }

  public destroy(): void {
    this.engine.destroy();
    this.devPanel.destroy();
  }
}

injected(
  ClickerGameScene,
  DI_TOKENS.gcsEngine,
  DI_TOKENS.clickerGameStartUpScript,
  DI_TOKENS.clickerGameSpawnBonusesScript,
  DI_TOKENS.clickerGameBonusesObserverScript,
  DI_TOKENS.clickerGameOnboardingScript,
  DI_TOKENS.clickerGameVisibilityChangeScript,
  DI_TOKENS.devPanelService,
);
